import { useState } from "react"
import Typography from "aldoo-ra/Typography"
import { PlusIcon, MinusIcon } from "@heroicons/react/24/outline"
import TextBundle from "aldoo-ra/CMS/text-bundle"

export default function FAQ({ items }) {
  const texts = TextBundle({ id: "transfer_faq" })
  const [openIndex, setOpenIndex] = useState(null)

  const faqs = items ?? [
    { question: texts?.faq1q, answer: texts?.faq1a },
    { question: texts?.faq2q, answer: texts?.faq2a },
    { question: texts?.faq3q, answer: texts?.faq3a },
    { question: texts?.faq4q, answer: texts?.faq4a },
    { question: texts?.faq5q, answer: texts?.faq5a },
    { question: texts?.faq6q, answer: texts?.faq6a },
    { question: texts?.faq7q, answer: texts?.faq7a },
    { question: texts?.faq8q, answer: texts?.faq8a },
  ].filter((f) => f.question)

  return (
    <section id="faq" className="w-full scroll-mt-20 bg-canvas rounded-t-[30px] sm:rounded-t-[50px] md:rounded-t-[75px] xl:rounded-t-[100px] py-10 sm:py-16 md:py-28 px-4">
      <div className="max-w-3xl mx-auto">
        <Typography
          variant="h2"
          className="text-center px-4 mb-10 sm:mb-14 md:mb-16 lg:mb-20"
        >
          {texts?.faqTitle}
        </Typography>

        <div className="bg-paper border border-theme_black rounded-[2rem] md:rounded-[3rem] p-2 md:p-8">
          {faqs.map((faq, index) => (
            <div key={index} className="border-b border-bordered last:border-0">
              <button
                onClick={() => setOpenIndex(openIndex === index ? null : index)}
                className="w-full py-6 px-4 md:px-6 flex items-center justify-between text-left focus:outline-none group transition-colors hover:bg-canvas/50 rounded-xl my-1"
                aria-expanded={openIndex === index}
              >
                <span className={`text-lg font-bold transition-colors ${
                  openIndex === index ? "text-link" : "text-text_secondary group-hover:text-text"
                }`}>
                  {faq.question}
                </span>

                <span className={`ml-6 flex-shrink-0 p-1 rounded-full border transition-all duration-300 ${
                  openIndex === index
                    ? "border-link/50 rotate-180"
                    : "border-link/50 group-hover:border-link/70"
                }`}>
                  {openIndex === index ? (
                    <MinusIcon className="w-5 h-5 text-link" />
                  ) : (
                    <PlusIcon className="w-5 h-5 text-text_secondary group-hover:text-text" />
                  )}
                </span>
              </button>

              <div className={`grid transition-[grid-template-rows] duration-300 ease-in-out ${
                openIndex === index ? "grid-rows-[1fr] opacity-100" : "grid-rows-[0fr] opacity-0"
              }`}>
                <div className="overflow-hidden">
                  <p className="text-text_secondary text-base leading-relaxed px-4 md:px-6 pb-6 pt-2">
                    {faq.answer}
                  </p>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  )
}
